import { Button, Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AdvancedSettingsModal } from '@hero/components/modals';

import * as S from './style';

export function ReviewFooter({ isLoading = false, settings, charities, onSettings, onSubmit }) {
  const { t } = useTranslation();
  const [isAdvancedSettingsModalOpen, setIsAdvancedSettingsModalOpen] = useState(false);

  return (
    <S.ReviewFooterWrapper>
      <Button
        variant="link"
        color="fg"
        startIcon={<Icon name="settings" />}
        onClick={() => setIsAdvancedSettingsModalOpen(true)}
      >
        {t('advancedSettings')}
      </Button>
      <Button
        onClick={() => {
          onSubmit();
        }}
        loading={isLoading}
        endIcon={<Icon name="next" />}
      >
        {t('proceedToCheckout')}
      </Button>
      {isAdvancedSettingsModalOpen && (
        <AdvancedSettingsModal
          isLoading={isLoading}
          isOpen={isAdvancedSettingsModalOpen}
          onRequestClose={setIsAdvancedSettingsModalOpen}
          settings={settings}
          onSettings={onSettings}
          charities={charities}
        />
      )}
    </S.ReviewFooterWrapper>
  );
}

ReviewFooter.propTypes = {
  isLoading: PropTypes.bool,
  settings: PropTypes.shape({
    onlyCollectAddress: PropTypes.bool,
    disableScratchEffect: PropTypes.bool,
    receiveThankYouNotes: PropTypes.bool,
    disableReGifting: PropTypes.bool,
    allowPremiumDates: PropTypes.bool,
    charityRules: PropTypes.shape({
      enabled: PropTypes.bool,
      selectedCharities: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  onSettings: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
